import { Outlet, createFileRoute } from "@tanstack/react-router"

// Parent of the checks list and each check's page, so the "Data quality" tab stays active on both.
export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/data-quality")({
  component: Outlet,
})
